/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RegistrationFeeType = {
    None: 'None',
    All: 'All',
    NewOnly: 'NewOnly'
} as const;
export type RegistrationFeeType = typeof RegistrationFeeType[keyof typeof RegistrationFeeType];


export function instanceOfRegistrationFeeType(value: any): boolean {
    for (const key in RegistrationFeeType) {
        if (Object.prototype.hasOwnProperty.call(RegistrationFeeType, key)) {
            if (RegistrationFeeType[key as keyof typeof RegistrationFeeType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RegistrationFeeTypeFromJSON(json: any): RegistrationFeeType {
    return RegistrationFeeTypeFromJSONTyped(json, false);
}

export function RegistrationFeeTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegistrationFeeType {
    return json as RegistrationFeeType;
}

export function RegistrationFeeTypeToJSON(value?: RegistrationFeeType | null): any {
    return value as any;
}

export function RegistrationFeeTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): RegistrationFeeType {
    return value as RegistrationFeeType;
}

